<template>
  <modal name="export" :width="400" :adaptive="true">
    <card class="ta-center p-b-5">
      <!-- <div class="modal-close-btn" @click="$modal.hide('export')">
        <i class="ti-close"></i>
      </div> -->
      <!-- <span @click="$modal.hide('export')" class="nova-modal-close d-flex" style="right: -13px;top: -13px;">
        <div class="__btn"></div><div class="__circle"></div>
        <i class="ti-close"></i>
        <svg class="svg-angle svg-angle-left" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
        <svg class="svg-angle svg-angle-right" width="29" height="29" viewBox="0 0 29 29" xmlns="http://www.w3.org/2000/svg"><path d="M0 29V0C0 16.0163 12.9837 29 29 29H0Z"/></svg>
      </span> -->
      <nova-close @click="$modal.hide('export')" class="d-flex"/>
      <h4 v-if="!dateAt">Нажмите "Начать экспорт"</h4>
      <h4 v-else-if="dateAt">Процесс запущен {{ dateAt }}</h4>

      <button
        :disabled="isStarted"
        v-if="isStarted === false && isDone === false"
        class="btn btn-info btn-icon"
        @click="start"
        style="min-width: 180px;"
      >
        <span class="ti-upload"></span>
        Начать экспорт
      </button>

      <h4 v-if="isStarted === true && isDone === false">Идет выгрузка...</h4>

      <download-excel
        v-if="isDone === true"
        :data="data"
        :fields="exportFields"
        :name="'_export.xls'"
      >
        <button :disabled="isStarted" class="btn btn-info btn-icon w-100">
          <span class="ti-upload"></span> Скачать Excel
        </button>
      </download-excel>
      <hr />
      <button
        :disabled="isStarted"
        class="btn btn-warning btn-icon"
        style="min-width: 180px;"
        @click="cancel"
      >
        Отмена / сброс
      </button>
    </card>
  </modal>
</template>
<script>
import downloadExcel from "vue-json-excel";
export default {
  components: {
    downloadExcel,
  },
  name: "export",
  props: {
    exportFields: {
      default: function () {
        return {};
      },
    },
    params: {
      default: function () {
        return {};
      },
    },
    itemLink: {
      default: function () {
        return "";
      },
    },
  },
  methods: {
    cancel() {
      this.$modal.hide("export");
      this.isDone = false;
      this.isStarted = false;
      this.dateAt = null;
      this.data = [];
    },
    start() {
      this.$dialog
        .confirm(
          "Вы точно хотите начать экспорт? Это может занять несколько минут, в зависимости от кол-во товаров.",
          {
            okText: "Начать экспорт",
            cancelText: "Отмена",
          }
        )
        .then(() => {
          this.page = 1;
          this.data = [];
          this.$loading(true);
          this.isStarted = true;
          this.dateAt = new Date();
          this.export();
        })
        .catch(() => {});
    },

    async export() {
      let params = JSON.parse(JSON.stringify(this.params));
      params["page"] = this.page;
      params["per_page"] = 100;
      await this.$http
        .get(this.itemLink, {
          params: params,
        })
        .then((response) => {
          if (response.data && response.data.data) {
            if (response.data.data.length) {
              this.data.push(...response.data.data);
              this.page++;
              setTimeout(() => {
                this.export();
              }, 10);
            } else {
              this.isDone = true;
              this.isStarted = false;
              this.$loading(false);
            }
          }
        })
        .catch(() => {
          this.$loading(false);
        })
        .finally(() => {});
    },
  },
  data() {
    return {
      isStarted: false,
      isDone: false,
      dateAt: null,
      data: [],
      page: 1,
    };
  },
};
</script>
<style>
</style>
